module.exports = __webpack_public_path__ + "img/about-icon_1.2f15677d.png";